import { PropsWithChildren } from "react";
import { cn } from "@/lib/utils";

interface InsetWellProps {
  className?: string;
}

export const InsetWell = ({
  children,
  className,
}: PropsWithChildren<InsetWellProps>) => (
  <div
    className={cn(
      "mb-4 rounded-lg border border-border bg-muted/50 p-4",
      className,
    )}
  >
    {children}
  </div>
);
